import { render, staticRenderFns } from "./ProductDetail7.vue?vue&type=template&id=21069878&scoped=true"
import script from "./ProductDetail7.vue?vue&type=script&lang=js"
export * from "./ProductDetail7.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail7.vue?vue&type=style&index=0&id=21069878&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21069878",
  null
  
)

export default component.exports